module.exports = __webpack_public_path__ + "img/128.953cd797.png";